/**
 * Created by mqamhieh on 12/26/16.
 */
(function (angular) {

    app.controller('MessageCandidateModal', [
        '$scope', 'modalData', 'Upload', '$modal',
        function ($scope, modalData, Upload, $modal) {

            $scope.close = function () {
                $scope.$hide();
            };

            var showManageLanesModal = function (preTemplateData) {
                $modal({
                    controller: 'ManageLaneTemplatesModal',
                    templateUrl: '../modules/ams/modals/manage_lane_templates/manage_lane_templates_modal.html',
                    show: true,
                    backdrop: 'static',
                    resolve: {
                        modalData: function () {
                            return {
                                jobId: modalData.jobId,
                                brandId: modalData.brandId,
                                laneId: modalData.laneId,
                                startTemplate: preTemplateData
                            };
                        },
                        onClose: function () {}
                    }
                });
            };

            $scope.amsMessageCandidateForm = new AMSMessageCandidateForm($scope, Upload, modalData.all, { jobId: modalData.jobId, brandId: modalData.brandId });
            $scope.amsMessageCandidateForm.setSelected(modalData.selected);

            $scope.amsMessageCandidateForm.on("done", function (data, attachements, hadNoTemplates) {
                if (hadNoTemplates) {
                    hConfirm({
                        'title': $filter('translate')('Message sent!'),
                        'text': $filter('translate')('Do you want to save this message as a template, for later use?'),
                        confirmButton: $filter("translate")("Save as template"),
                        cancelButton: $filter("translate")("No, thanks!"),
                        callback: function (confirmed) {
                            if (confirmed) {
                                showManageLanesModal({
                                    'message': data.message,
                                    'new_attachments': attachements
                                });
                            }

                            $scope.close();
                            $scope.$digest();
                        }
                    });
                }
                else {
                    $scope.close();
                    $scope.$digest();
                }
            });

            $scope.amsMessageCandidateForm.load(modalData.laneId);

        }]);
})
(angular.module('harriApp'));